<template>
  <chart-card title="Faturamento" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-currency />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    listaFaturamentoMensal: [],
    listaFaturamentoSemanal: [],
    listaFaturamentoDiario: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        segmentos: this.stateFilters.segments,
      }
    },
    faturamento() {
      if (this.filterType === 'mensal') return this.faturamentoMensal
      if (this.filterType === 'semanal') return this.faturamentoSemanal
      if (this.filterType === 'diario') return this.faturamentoDiario
      return ''
    },
    faturamentoMensal() {
      return helpers.agrupamentoMensal(this.listaFaturamentoMensal, 'VAL_FATURAMENTO')
    },
    faturamentoSemanal() {
      return helpers.agrupamentoSemanal(this.listaFaturamentoSemanal, 'VAL_FATURAMENTO')
    },
    faturamentoDiario() {
      return helpers.agrupamentoDiario(this.listaFaturamentoDiario, 'VAL_FATURAMENTO')
    },
    chartData() {
      return {
        labels: [...this.faturamento.map((object) => object.data)],
        datasets: [
          {
            label: 'Faturamento',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.faturamento.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      empresaFaturamento: 'faturamento',
    }),
    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.empresaFaturamento({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.listaFaturamentoMensal = data
          })
        } else if (this.filterType === 'semanal') {
          await this.empresaFaturamento({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.listaFaturamentoSemanal = data
          })
        } else if (this.filterType === 'diario') {
          await this.empresaFaturamento({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.listaFaturamentoDiario = data
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
